/**
 * Returns sentenceBegin and sentenceEnd from the new text, which includes the word before the respective search value,
 * the letters before and after the highlight (if the search value is in the middle of a word) and the rest of the sentence
 */
export const showOneWordBeforeHighlight = (
    offset: number,
    indexArr: number[],
    text: string,
    textLength: number,
    highlightLength: number,
): string[] => {
    const indexOfTextOffset = indexArr.indexOf(offset);
    const substringStart = indexArr[indexOfTextOffset - 2];
    const newText = text.substring(substringStart).trim();
    const newOffset = offset - (textLength - newText.length);
    const sentenceBegin = newText.substring(0, newOffset);
    const sentenceEnd = newText.substring(newOffset + highlightLength);
    return [sentenceBegin, sentenceEnd];
};
